<template>
  <div>
    <b-overlay :show="is_loading">
      <b-row>
        <b-col>
          <b-card>
            <div>
              <b-form @submit.prevent="fetch(1)">
                <b-row>
                  <b-col v-if="$can('voir-marchand-concession', 'marchand') || $can('voir-marchand-global', 'marchand')">
                    <v-select :reduce="item => item.id" v-model="filter.concession_id" label="libelle" :options="$store.state.initialConfigModule.initialState.concessions" placeholder="Rechercher par concession"></v-select>
                  </b-col>
                  <b-col v-if="$can('voir-marchand-concession', 'marchand') || $can('voir-marchand-site', 'marchand') || $can('voir-marchand-global', 'marchand')">
                    <v-select :reduce="item => item.id" v-model="filter.site_id" label="libelle" :options="$store.state.initialConfigModule.initialState.sites" placeholder="Rechercher par site"></v-select>
                  </b-col>
                  <b-col md="auto">
                    <b-button type="submit" variant="primary">Recherche</b-button>
                    <b-button v-if="hasAnyFilter" type="button" variant="flat-danger" class="ml-1" @click="resetFilters">
                      <feather-icon icon="XIcon" size="14" class="mr-25" />
                      Réinitialiser
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-card no-body>
        <div class="m-2 d-flex justify-content-end">
          <div class="align-self-center">
            {{pagination.total}} véhicules vendus
          </div>
        </div>

        <b-table v-if="items"
                 :fields="fields"
                 :items="items"
                 responsive
                 class="mb-0"
        >
          <template #cell(vehicule)="data">
            <vehicule-overview v-if="data.item.vehicule" :with-image="false" :vehicule="data.item.vehicule" />
            <span v-else>-</span>
          </template>
          <template #cell(offre_id)="data">
            <b-link
                v-if="data.item.offre_id"
                :to="{ name: 'editer-offre-marchand', params: { id: data.item.offre_id } }"
            >
              Offre N°{{ data.item.offre_id }}
            </b-link>
            <span v-else>-</span>
          </template>
          <template #cell(client)="data">
            <span class="font-weight-bold">{{ data.item.client ? data.item.client.full_name : '-' }}</span>
          </template>
          <template #cell(vendeur)="data">
            <span class="font-weight-bold">{{ data.item.vendeur ? data.item.vendeur.full_name : '-' }}</span>
          </template>
          <template #cell(prix)="data">
            {{ (data.item.prix || 0).toLocaleString('en') }} Dhs
          </template>
          <template #cell(actions)="data">
            <feather-icon
                v-if="data.item.document"
                v-b-tooltip.hover.top="'Bon de commande'"
                icon="PrinterIcon"
                size="16"
                class="mx-1 cursor-pointer"
                @click="printClickHandler(data.item)"
            />
          </template>
        </b-table>
      </b-card>
    </b-overlay>

    <b-row v-if="!is_loading && items.length == 0">
      <b-col>
        <b-card class="text-center">
          Aucun véhicule vendu en B2B
        </b-card>
      </b-col>
    </b-row>

    <div class="mx-2 mb-2">
      <b-row>
        <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
              v-model="pagination.current_page"
              :total-rows="pagination.total"
              :per-page="pagination.per_page"
              first-number
              last-number
              @change="fetch"
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BTable, BButton, BCard, BRow, BCol, BForm, BOverlay, BPagination, BLink, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import VehiculeOverview from "@/components/Vehicule/VehiculeOverview";
import axios from "@/libs/axios";
import filterPersistence from '@/mixins/filterPersistence'

export default {
  name: "VenduB2BPage",
  mixins: [filterPersistence],
  components: {
    VehiculeOverview,
    BCard,
    BTable,
    BButton,
    BRow,
    BCol,
    BForm,
    BOverlay,
    BPagination,
    BLink,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      filterKey: 'vendu-b2b-list',
      fields: [
        { key: 'vehicule', label: 'Véhicule' },
        { key: 'offre_id', label: 'Num Offre' },
        { key: 'client', label: 'Client' },
        { key: 'vendeur', label: 'Vendeur' },
        { key: 'prix', label: 'Prix' },
        { key: 'date', label: 'Date de vente' },
        { key: 'actions', label: '' },
      ],
      items: [],
      pagination: {},
      is_loading: false,
      filter: {
        concession_id: null,
        site_id: null,
      }
    }
  },
  created() {
    this.fetch(this.restoredPage || 1);
  },
  computed: {
    hasAnyFilter() {
      const f = this.filter || {};
      return Object.keys(f).some(k => {
        const v = f[k];
        return v !== null && v !== '' && !(Array.isArray(v) && v.length === 0);
      });
    }
  },
  methods: {
    resetFilters() {
      this.resetFilter();
      this.fetch(1);
    },
    printClickHandler(item) {
      if (item.document) {
        window.open(item.document, '_blank');
      }
    },
    fetch(page) {
      let _this = this;
      _this.is_loading = true;
      axios.get('/api/marchands/vendu-b2b', {
        params: {
          page: page,
          ..._this.filter
        }
      }).then(function (response) {
        _this.items = response.data.data;
        _this.pagination = response.data.meta;
        _this.is_loading = false;
      }).catch(function () {
        _this.is_loading = false;
      });
    }
  },
}
</script>
